module.exports = __webpack_public_path__ + "static/img/264.63628d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/264.png
// module id = dZ2F
// module chunks = 0